import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { formatCurrency } from '../../../../../helpers/utils';

const InvoiceTotal = ({ total }) => {
  const { t } = useTranslation();

  return (
    <div className={'invoice-total'}>
      <div className={`${total < 0 ? 'error' : ''}inner`}>
        <span>{t('billing.invoiceCreation.summary.totalLabel')}:</span> <strong>{formatCurrency(total)}</strong>
      </div>
    </div>
  );
};

InvoiceTotal.propTypes = {
  total: PropTypes.number.isRequired,
};

export default InvoiceTotal;
